export default __webpack_public_path__ + "static/media/head03_ja_sp.fcdcec16.png";